import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { getIconStyles as C } from "../styles.js";
const L = (e) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: C(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_4698_16887)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.424 0.780522C22.393 0.93165 23.0864 1.68717 23.2235 2.74125C23.2417 2.88105 23.2473 5.67691 23.2425 12.168L23.2356 21.396L23.1701 21.6337C22.9436 22.4548 22.3811 22.9684 21.4527 23.2016C21.3033 23.2391 20.6265 23.2426 12.1116 23.2501C5.58726 23.2558 2.8645 23.2505 2.69955 23.2319C2.39475 23.1975 2.1872 23.1368 1.92363 23.0051C1.3549 22.7208 0.983889 22.2271 0.801632 21.5119L0.747633 21.3V11.976C0.747633 3.25264 0.750298 2.64009 0.788841 2.46729C0.887337 2.02576 1.05913 1.71179 1.37065 1.40399C1.60587 1.1716 1.8734 1.00699 2.19334 0.89781C2.68086 0.731442 1.88067 0.743754 12.0368 0.746322C19.5443 0.748218 21.2569 0.754458 21.424 0.780522ZM21.2436 2.27843C21.4833 2.33678 21.6456 2.52938 21.7101 2.83199C21.7314 2.93193 21.7364 5.18457 21.7309 12.108L21.7236 21.252L21.6736 21.36C21.6096 21.4984 21.488 21.6044 21.3116 21.6755L21.1716 21.732L19.2096 21.7387L17.2476 21.7453V12.0007V2.25599L19.2096 2.25844C20.2887 2.25981 21.204 2.26879 21.2436 2.27843ZM15.7356 12V21.7444L9.23763 21.7382L2.73963 21.732L2.63163 21.682C2.4932 21.6179 2.38724 21.4963 2.3161 21.32L2.25963 21.18L2.25351 12.0126C2.2466 1.68583 2.22771 2.67249 2.4363 2.47199C2.4981 2.41259 2.60242 2.34239 2.66814 2.31599C2.78646 2.26847 2.85085 2.26792 9.26163 2.26178L15.7356 2.25556V12Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_4698_16887", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  L as LayoutRightIcon
};
//# sourceMappingURL=LayoutRightIcon.js.map
